import { render, staticRenderFns } from "./lab-card.vue?vue&type=template&id=6fcc8900&"
import script from "./lab-card.vue?vue&type=script&lang=js&"
export * from "./lab-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fcc8900')) {
      api.createRecord('6fcc8900', component.options)
    } else {
      api.reload('6fcc8900', component.options)
    }
    module.hot.accept("./lab-card.vue?vue&type=template&id=6fcc8900&", function () {
      api.rerender('6fcc8900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/labs/lab-card.vue"
export default component.exports